import SmoothScroll from 'smooth-scroll'

export default class EventEnquiry {
  /**
  * Constructs a new EventEnquiry instance.
  * @param {object} options - Options.
  */
  constructor (options) {
    this.element = options.element
    this.hurdler = options.hurdler
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 500,
      header: '[data-component="global-header"]',
      updateURL: false
    }

    const self = this
    this.hurdler.hurdles.push({
      test: function () {
        return this === self.element
      },
      callback: function () {
        self.scroll.animateScroll(self.element, self.element, self.scrollOptions)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/events/event-enquiry/index.js